import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import Iconify from 'src/components/iconify';
import PaymentFollowUpReceiveable from './payment-req-follow-up-modal';
import { formatCurrency } from '../../../risk-register/feching';
// ----------------------------------------------------------------------

export default function UserTableRow({
  row,
  reloadBankInfo,
  selected,
  onEditRow,
  onSelectRow,
  onDeleteRow,
  serialNumber,
  chartsAccountList,
  bankInformation,
  reload,
}) {
  const { period_thru, sov_grand_total, payment_due, total_amount_paid } = row;

  const balance_to_completion = sov_grand_total.balance_to_finish - total_amount_paid;

  const confirm = useBoolean();
  const create = useBoolean();
  const popover = usePopover();

  const dateformation = (date) => {
    if (!date) return '';
    const parsedDate = new Date(date);
    if (isNaN(parsedDate)) return '';
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, '0');
    const day = parsedDate.getDate().toString().padStart(2, '0');
    const year = parsedDate.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return (
    <>
      <TableRow hover selected={selected}>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
        <TableCell>{serialNumber}</TableCell>
        <TableCell style={{ cursor: 'pointer', color: 'blue' }} onClick={create.onTrue}>
          {serialNumber}
        </TableCell>
        <TableCell>{dateformation(period_thru)}</TableCell>
        <TableCell>{dateformation(payment_due)}</TableCell>
        <TableCell>{formatCurrency(sov_grand_total?.work_completed_before)}</TableCell>
        <TableCell>{formatCurrency(sov_grand_total?.work_completed_this_duration)}</TableCell>
        <TableCell>{sov_grand_total.materials_stock}</TableCell>
        <TableCell>{formatCurrency(sov_grand_total.total_completed_plus_stock)}</TableCell>
        <TableCell>{sov_grand_total?.percentage_of_planned_work}%</TableCell>
        <TableCell>{formatCurrency(sov_grand_total.schedule_value)}</TableCell>
        <TableCell>{formatCurrency(total_amount_paid)}</TableCell>
        <TableCell>{formatCurrency(balance_to_completion)}</TableCell>
        <TableCell>{formatCurrency(sov_grand_total.retainage_of_work_completed)}</TableCell>
        <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
          <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
            <Iconify icon="eva:more-vertical-fill" />
          </IconButton>
        </TableCell>
      </TableRow>
      <PaymentFollowUpReceiveable
        open={create.value}
        currentItem={row}
        onClose={create.onFalse}
        chartsAccountList={chartsAccountList}
        balance_to_completion={balance_to_completion}
        // outstanding_balance={outstanding_balance}
        bankInformation={bankInformation}
        // invoice_number={/payment-requisitions}
        reload={reload}
        reloadBankInfo={reloadBankInfo}
        remaining_balance={balance_to_completion}
        // amount_paid={amount_paid}
      />
      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top"
        sx={{ width: 140 }}
      >
        <MenuItem
          onClick={() => {
            confirm.onTrue();
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Delete
        </MenuItem>
        <MenuItem
          onClick={() => {
            onEditRow(row);
            console.log('>>>>>>>', row);
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Edit
        </MenuItem>
      </CustomPopover>
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Delete"
        content="Are you sure you want to delete?"
        action={
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              confirm.onFalse();
              onDeleteRow(row.id);
              console.log('>>>>>>>', row.id);
            }}
          >
            Delete
          </Button>
        }
      />
    </>
  );
}
UserTableRow.propTypes = {
  onDeleteRow: PropTypes.func,
  onEditRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  row: PropTypes.object,
  selected: PropTypes.bool,
};
